var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"offer-code",attrs:{"href":_vm.offerAbsoluteUrl,"target":"_blank"}},[_c('a-icon',{style:({ marginRight: '4px' }),attrs:{"type":"link"}}),(_vm.hasSlot('content'))?_vm._t("content"):[_vm._v(" "+_vm._s(_vm.offerCode)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }